// --- React
import React from "react";
// --- External UI Libraries
import Input from "@dtci/spellbook/Input";
// --- Styles
import "./styles.scss";

/**
 * Text input with an inline clear button when the field has a value.
 * @param {Object} props
 * @param {string} props.value - Current input value
 * @param {Function} props.onChange - Input change handler
 * @param {Function} props.onClear - Clears the field value
 */
export function ClearableFilterInput({
  value,
  onChange,
  onClear,
  className,
  ...inputProps
}) {
  const hasValue = Boolean(value);

  return (
    <div
      className={`clearable-filter-input${hasValue ? " clearable-filter-input--has-value" : ""}`}
    >
      <Input
        value={value}
        onChange={onChange}
        className={className}
        {...inputProps}
      />
      {hasValue && (
        <button
          type="button"
          className="clearable-filter-input__clear"
          onClick={onClear}
          aria-label="Clear"
        >
          <i className="fa-solid fa-xmark" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
